/* eslint-disable import/prefer-default-export */
export const applicationStatusData = {
  agentName: "Application Status Agent",
  pageTitle: "Application Status Agent",
  title: "Application Status Agent",
  subtitle: "Agentic Apps",

  actionItems: [
    {
      text: "Case #4325 ",
      type: "warning",
      link: "#",
      linkText: "Case",
      duration: "12 days in",
      status: "For Design",
    },
    {
      text: "Case #3333 ",
      type: "danger",
      link: "#",
      linkText: "Case",
      duration: "14 days in",
      status: "For Awaiting",
    },
    {
      text: "Case #3333 ",
      type: "danger",
      link: "#",
      linkText: "Case",
      duration: "8 days in",
      status: "For Awaiting",
    },
    {
      text: "Case #4325 ",
      type: "info",
      link: "#",
      linkText: "Case",
      duration: "7 days in",
      status: "Pre-Construction",
    },

    {
      text: "Case #4325 ",
      type: "warning",
      link: "#",
      linkText: "Case",
      duration: "9 days in",
      status: "For Design",
    },

    {
      text: "Case #4325 ",
      type: "info",
      link: "#",
      linkText: "Case",
      duration: "14 days in",
      status: "Pre-Construction",
    },

  ],

  entries: [
    {
      icon: "JS",
      text: 'Assigned to <strong>John Smith</strong>.',
      meta: "just now",
      badge: "For Pre-construction",
      links: [
        { label: "Ask Application Status Agent", href: "#open" },
      ],
    },
    {
      icon: "LG",
      text: 'Assigned to <strong>Lois Griffin</strong>.',
      meta: "2 hr ago",
      badge: "For Design",
      links: [
        { label: "Ask Application Status Agent", href: "#open" },
      ],
    },
  ],

};
